<div class="maintenance-wrapper">
<div class="maintenance-container" style="overflow-y: hidden;">
  <div class="maintenance-content">

    <div style="border: 2px solid white;height: 45px ; width: 45px;margin: auto;background-color: white;border-radius: 40px;display: flex;align-items: center;justify-content: center;">
        <mat-icon style="color: #d6433b;margin: auto;">warning</mat-icon>
    </div>

    <h1 class="maintenance-message">We’ll be back soon!</h1>
    <p class="maintenance-subtext">Sorry fo the inconvenience. We're performing site maintenance <br> at the moment. We'll be back up shortly!</p>
    <p class="maintenance-subtext">-The GRS Team (grs&#64;us.mcd.com) </p>

  </div>
</div>
</div>